const isAllowed = (item, { canDisplay, isAdmin }) => {
  if (item.adminOnly && !isAdmin) return false;
  if (item.alwaysShow) return true;
  if (item.resource) return canDisplay(item.resource);
  return true;
};

export const resolveNavigationItems = (items, access) => items.flatMap(
  (item) => {
    if (!isAllowed(item, access)) return [];
    if (!item.children) return [item];

    const children = item.children.filter((childItem) => (
      isAllowed(childItem, access)
    ));

    if (children.length === 0) return [];
    if (children.length === 1) return children;

    return [{ ...item, children }];
  },
);

export const isNavigationItemActive = (item, pathname) => {
  if (item.children) {
    return item.children.some((childItem) => (
      isNavigationItemActive(childItem, pathname)
    ));
  }

  if (!item.path) return false;
  if (pathname === item.path) return true;

  return item.path !== '/' && pathname.startsWith(`${item.path}/`);
};
